export function setPrivatePageTitle(masterData) {
  try {
    const { productLevel } = masterData ?? {};
    document.title = productLevel?.displayName
      ? productLevel?.displayName
      : 'WorkforceHub Time';
  } catch (error) {
    console.error('Error setting page title', error);
  }
}

export function setPrivatePartnerPageTitle() {
  try {
    document.title = `Provider Portal`;
  } catch (error) {
    console.error('Error setting partner page title', error);
  }
}

export function setPublicPageTitle(title) {
  try {
    document.title = `WorkforceHub ${title}`;
  } catch (error) {
    console.error('Error setting public page title', error);
  }
}
